<template>
    <div class="cmp-distribution-dashboard-main-container">
        <div style="display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 8px;" class="dt-page--top-bar v1">
            <div class="right-container ut-colcen">
                <!-- <div class="ut-flex">
                    <button class="dt-button v7 s8" :class="{
                        active:
                            searchType == 'release_standard_search' || searchType == 'none',
                    }" @click="(e) => onFilterButtonClicked('release_standard_search')">
                        {{ $t("standard") }}
                    </button>
                    <button class="dt-button v7 s8" :class="{
                        active: searchType == 'release_weekly_search',
                    }" @click="(e) => onFilterButtonClicked('release_weekly_search')">
                        {{ $t("weekly") }}
                    </button>
                    <button class="dt-button v7 s8" :class="{
                        active: searchType == 'release_monthly_search',
                    }" @click="(e) => onFilterButtonClicked('release_monthly_search')">
                        {{ $dft.capHead($t("monthly")) }}
                    </button>


                </div> -->
            </div>
        </div>
        <div class="distribution-dashboard-container">

            <div class="chart-container">
                <div class="chart-content">
                    <span class="chart_header">{{ $t('12_month_total') }}</span>
                    <div v-if="showData" class="chart">
                        <div class="legend">
                            <v-list>
                                <v-list-tile v-for="(label, i) in categoryGraphData.labels" :key="i"
                                    @click="onClick(label, i)">
                                    <div style="width: 10px;
                   height: 10px; border-radius: 50px;" :style="{
                    backgroundColor: `${categoryGraphData.datasets[0].backgroundColor[i]}`,
                }"></div>
                                    <v-list-tile-content>
                                        <v-list-tile-title :class="{ strikethrough: label.click }">
                                            {{ $dft.capHead($t(label.text)) }} {{ label.salePercentage
                                            }}</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </div>
                        <div class="chart_">
                            <DoughnutChart :chartdata="categoryGraphData" />
                        </div>
                    </div>
                </div>
                <div class="chart-content">
                    <span class="chart_header">{{ periodGraphData.labels[0] }} -
                        {{ periodGraphData.labels[periodGraphData.labels.length - 1] }}</span>

                    <div v-if="showData" class="chart">

                        <div class="chart_">
                            <BarVerticalChart :chartdata="periodGraphData" />
                        </div>
                    </div>
                </div>

            </div>
            <div class="table-container">
                <CategoryTable :items="items" :headers="headers" />
            </div>
        </div>

    </div>
</template>

<script>

import { mapGetters, mapActions } from "vuex";
import { GChart } from "vue-google-charts";
import BarVerticalChart from "./charts/bar-vertical-chart";
import DoughnutChart from "./charts/doughnut-chart";
import CategoryTable from "./category-table.vue";
import { DashboardService } from "../../services/dashboard.service";
import {
    createNTableConfig,
    createTableHeader,
} from "../../../../plugins/datatable";
import { isNumber } from "ramda-adjunct";
const borderRadiusAllCorners = { topLeft: 15, bottomLeft: 15 };
export default {
    components: {
        GChart,
        BarVerticalChart,
        CategoryTable,
        DoughnutChart
    },

    data() {
        return {
            searchType: 'none',
            dashboardData: null,
            headers: [],
            items: [],
            showData: false,
            periodsData: []
        };
    },
    created() { },
    async mounted() {
        const res = await DashboardService.getDashboardData();
        let dashboardData =res.data.data;
        let dashboardDataArray = [];
        dashboardData = dashboardData.map(x => {
            x.forEach((item, index) => {
                if (index > 0) {
                    dashboardDataArray.push([
                        index == 1 ? 'channel_physical' : index == 2 ? 'channel_digital' : index == 3 ? 'channel_licencing' : 'channel_performance',
                        x[0],
                        item
                    ])

                }


            })

            return x;

        });
        //index == 1 ? Math.ceil(Math.random() * 9999) * (Math.round(Math.random()) ? 1 : -1) :
        dashboardDataArray = dashboardDataArray.map(x => ({
            name: x[0],
            period: x[1],
            value: x[2]
        }));
        let periodGrp = Object.groupBy(dashboardDataArray, ({ period }) => period);
        let periodGrpkeys = Object.keys(periodGrp);
        periodGrpkeys.forEach(key => {
            let values = periodGrp[key];
            if (values.filter(v => v.value == 0).length == values.length) {
                dashboardDataArray = dashboardDataArray.filter(a => a.period !== key)
            }
        })
        this.dashboardData = [...dashboardDataArray]
        let result = Object.groupBy(this.dashboardData, ({ name }) => name);
        let items = [];
        let colors = ["#64C896",
            "#E6DC64",
            "#FF6E6E",
            "#7878F0",
            "#E682BE",]
        let resultGrpkeys = Object.keys(result);
        resultGrpkeys.forEach(key => {
            let values = result[key];
            if (values.filter(v => v.value == 0).length == values.length) {
                delete result[key]
            }
        })
        this.periodsData = result;
        Object.keys(result).forEach((key, index) => {
            let obj = {};
            result[key].forEach(item => {
                obj[item.period] = item.value
            });
            console.log(obj)
            obj = {
                ...obj,
                "color": colors[index],
                "category": key,
                "total": this.getTotal(result[key], 'value')
            }
            items.push(obj);

        })
        this.items = [...items]
        console.log('this.items', this.items)
        this.showData = true;
        let periods = Object.groupBy(dashboardDataArray, ({ period }) => period);
        var keys = Object.keys(periods);
        console.log(keys)
        let headers = keys.map(h => {
            return {
                ...createTableHeader(h, { f: 1.1, ta: 'right' }),
            }


        })
        headers.unshift({
            ...createTableHeader('category', { mw: 150, minw: 130 }),
        })
        headers.push({
            ...createTableHeader('total', { f: 1.3, ta: 'right' }),
        });
        this.headers = [...headers]
        console.log('headers', headers);
    },
    computed: {
        categoryGraphData: function () {
            if (!this.items) {
                return {};
            }

            let chartData = {
                labels: [],
                datasets: [
                    {
                        label: "Digital Turnover",
                        backgroundColor: "#4FE890",
                        data: [],
                        backgroundColor: [
                            "#64C896",
                            "#E6DC64",
                            "#FF6E6E",
                            "#7878F0",
                            "#E682BE",

                        ],
                    },
                ],
            };
            let categoryGraphItems = this.items.map((c) => {
                c.total = !isNumber(c?.total)
                    ? c?.total?.replace(/\,/g, "")
                    : c?.total;
                return c;
            });
            const totalGraphData = categoryGraphItems
                .map((c) => Math.abs(c?.total))
                .reduce((accm, cur) => accm + cur, 0);

            categoryGraphItems.forEach((e) => {
                let salePercentage = (Math.abs(e.total) / totalGraphData) * 100;
                const label = e.category;
                chartData.labels.push({ text: this.$t(label), salePercentage: salePercentage.toFixed(1) + "%", click: false });
                chartData.datasets[0].data.push(e.total);
            });

            return chartData;
        },

        periodGraphData: function () {
            if (!this.periodsData) {
                return {};
            }

            let chartData = {
                labels: [],
                datasets: [
                    {
                        label: "",
                        backgroundColor: "#64C896",
                        data: [],
                        barThickness: 10,
                        barPercentage: 0.5,
                        borderWidth: 1,
                        borderRadius: borderRadiusAllCorners,
                        borderSkipped: 'end',
                        xAxis: {
                            labels: {
                                useHTML: true,
                                style: {
                                    width: 100,
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                },
                            },
                        },
                    },
                    {
                        label: "",
                        backgroundColor: "#E6DC64",
                        data: [],
                        barThickness: 10,
                        barPercentage: 0.5,
                        borderWidth: 1,
                        borderRadius: borderRadiusAllCorners,
                        borderSkipped: 'end',
                        xAxis: {
                            labels: {
                                useHTML: true,
                                style: {
                                    width: 100,
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                },
                            },
                        },
                    },
                    {
                        label: "",
                        backgroundColor: "#FF6E6E",
                        data: [],
                        barThickness: 10,
                        barPercentage: 0.5,
                        borderWidth: 1,
                        borderRadius: borderRadiusAllCorners,
                        borderSkipped: 'end',
                        xAxis: {
                            labels: {
                                useHTML: true,
                                style: {
                                    width: 100,
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                },
                            },
                        },
                    },
                    {
                        label: "",
                        backgroundColor: "#7878F0",
                        data: [],
                        barThickness: 10,
                        barPercentage: 0.5,
                        borderWidth: 1,
                        borderRadius: borderRadiusAllCorners,
                        borderSkipped: 'end',
                        xAxis: {
                            labels: {
                                useHTML: true,
                                style: {
                                    width: 100,
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                },
                            },
                        },
                    },

                ],
            };
            Object.keys(this.periodsData).forEach((key, index) => {
                chartData.datasets[index].label = key;
                console.log(this.periodsData[key])
                this.periodsData[key].forEach((c) => {
                    c.value = !isNumber(c?.value)
                        ? parseFloat(c?.value?.replace(/\,/g, ""))
                        : c?.value;
                    if (index === 0) {
                        chartData.labels.push(c.period);
                    }

                    chartData.datasets[index].data.push(c.value);
                });

            })


            return chartData;
        },
    },

    methods: {
        onFilterButtonClicked(e) {
            this.searchType = e;
        },
        getTotal(array, column) {
            return array && array.map(t => {
                return t[column] ? t[column] : 0
            }).reduce((acc, value) => acc + value, 0);
        },
        toPositive(n) {
            if (n < 0) {
                n = n * -1;
            }
            return n;
        }

    }

}

</script>

<style lang="scss">
.cmp-distribution-dashboard-main-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: calc(100vh - 145px);

    .distribution-dashboard-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 100%;
        overflow: auto;
        height: calc(100vh - 145px);

        .table-container {
            margin: 15px;
            overflow: auto;
            height: fit-content;

        }

        .chart-container {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            flex-wrap: wrap;
            width: 100%;
            position: relative;
            gap: 1rem;
            margin-top: 20px;
            margin-bottom: 30px;

            .chart-content {
                display: flex;
                border: 1px solid #fff;
                background: #ffffff 0% 0% no-repeat padding-box;
                border: 1px solid #C8C8C880;
                border-radius: 5px;
                opacity: 1;
                padding: 0px 20px;
                width: 48%;
                overflow: auto;
                flex-direction: column;
                height: 350px;

                @media (min-width: 320px) and (max-width: 800px) {
                    width: 100%;
                }

                &.full-content {
                    width: 98.5%;
                }

                .chart_header {
                    color: #282828;
                    font-size: 14px;
                    margin-top: 22px;
                    padding-bottom: 20px;
                    font-weight: 600;
                    text-transform: uppercase;
                }

                .chart_ {
                    display: flex;
                    flex-direction: column;
                    overflow: hidden;
                    padding: 5px;
                    height: 100%;
                    width: 100%;

                    div {
                        display: flex !important;
                        width: 100% !important;
                        max-width: 100% !important;
                        overflow: hidden;
                        margin: 30px 8px 60px 0;

                        canvas {
                            height: none !important;
                        }

                        @media (min-width: 320px) and (max-width: 800px) {
                            margin-bottom: 0px;
                        }
                    }
                }

                .chart {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    overflow: hidden;
                    height: 100%;
                    width: 100%;

                    .legend {
                        display: flex;
                        flex-direction: column;
                        margin-bottom: 60px;
                        overflow: hidden;
                        width: 30%;

                        @media only screen and (max-width: 992px) {
                            width: 50%;
                        }

                        .list__tile {
                            display: flex;
                            align-items: center;
                            height: 24px;
                            font-size: 13px;
                            padding: 0px;

                            .circle {
                                width: 10px;
                                height: 10px;
                                border-radius: 50px;
                            }

                            .list__tile__content {
                                padding-left: 5px;
                                cursor: pointer;
                                width: 100%;
                                line-height: 24px;

                                .list__tile__title {
                                    color: #5e5e5e;
                                    font-size: 13px;

                                    &.strikethrough {
                                        position: relative;
                                    }

                                    &.strikethrough:before {
                                        border-bottom: 2px solid #757373;
                                        position: absolute;
                                        content: "";
                                        width: 95%;
                                        height: 55%;
                                    }
                                }
                            }
                        }
                    }

                    .chart_ {
                        display: flex;
                        height: 100%;
                        overflow: hidden;
                        justify-content: flex-end;

                        div {
                            display: flex !important;
                            width: 100% !important;
                            max-width: 100% !important;
                            overflow: hidden;
                            margin: 30px 8px 60px 0;

                            canvas {
                                height: none !important;
                            }

                            @media (min-width: 320px) and (max-width: 800px) {
                                margin-bottom: 0px;
                            }
                        }
                    }
                }
            }
        }
    }



    .list__tile--link:hover {
        background: none !important;
    }
}
</style>